import React, { useRef } from 'react';
import './Partners.css';

// Dynamically require partner images from the folder.
// Make sure images exist at src/assets/images/partners/
let partnerImages = [];
try {
  const req = require.context('../../assets/images/partners', false, /\.(png|jpe?g|webp)$/);
  partnerImages = req.keys().map(req);
} catch (e) {
  // If folder is missing, leave empty
  partnerImages = [];
}

export default function Partners() {
  const trackRef = useRef(null);

  const scroll = (dir = 1) => {
    const track = trackRef.current;
    if (!track) return;
    const w = track.clientWidth;
    track.scrollBy({ left: dir * (w * 0.6), behavior: 'smooth' });
  };

  return (
    <section id="partners" className="partners-section" aria-labelledby="partners-heading">
      <h2 id="partners-heading" className="partners-heading">Partnerships</h2>
      {/* disable carousel for now and show text */}
      <div className="partners-text">
        <p>Styx engages with academic investigators, technology providers, and industry experts to strengthen the development of differentiated ADC therapeutics.</p>
        <p>While our programs are internally driven, we selectively collaborate with scientific and technical partners to enhance platform capabilities, translational validation, and development execution.</p>
        <h3>Our Approach</h3>
        <p>We believe strong science attracts strong partners. As our lead programs advance toward clinical development, we remain open to strategically aligned collaborations that accelerate patient impact while preserving long-term value creation.</p>
      </div>
    </section>
  );
}

